import React from "react";
import { github, gitlab } from "../../assets";

const VersionControl = () => {
  return (
    <div className="frontend_section">
      <h1 className="tech__heading">Version Control</h1>
      <div className="tech__section">
        <div>
          <img src={github} alt="github" className="tech__logo" />
          <p>Github</p>
        </div>

        <div>
          <img src={gitlab} alt="gitlab" className="tech__logo" />
          <p>Gitlab</p>
        </div>
      </div>
    </div>
  );
};

export default VersionControl;
